import React, { useState, useEffect, useCallback } from 'react';
import './GasCostCalculator.css'; // Reuse the same CSS file for styling

const carOptions = [
  { name: 'Tesla Model Y', value: 4.1 },
  { name: 'Tesla Model 3', value: 4.0 },
  { name: 'Ford Mustang Mach-E', value: 3.3 },
  { name: 'Hyundai Ioniq 5', value: 3.5 },
  { name: 'Tesla Cybertruck', value: 3.0 },
  { name: 'Ford F-150 Lightning', value: 2.5 },
  { name: 'Honda Prologue', value: 3.3 },
  { name: 'Chevrolet Equinox EV', value: 3.2 },
  { name: 'Cadillac Lyriq', value: 2.8 },
  { name: 'Rivian R1S', value: 2.3 },
];

const EVCostCalculator = () => {
  const [distance, setDistance] = useState(1000); // Default monthly distance
  const [pricePerKwh, setPricePerKwh] = useState(0.22); // Default price per kWh in dollars
  const [milesPerKwh, setMilesPerKwh] = useState(4); // Default miles per kWh
  const [selectedCar, setSelectedCar] = useState(''); // Default selected car
  const [monthlyCost, setMonthlyCost] = useState(0);
  const [yearlyCost, setYearlyCost] = useState(0);

  const calculateCosts = useCallback(() => {
    const monthlyCost = (distance / milesPerKwh) * pricePerKwh; // Calculate monthly cost
    const yearlyCost = monthlyCost * 12; // Calculate yearly cost
    setMonthlyCost(monthlyCost.toFixed(2));
    setYearlyCost(yearlyCost.toFixed(2));
  }, [distance, pricePerKwh, milesPerKwh]);

  useEffect(() => {
    calculateCosts(); // Calculate costs on initial load
  }, [distance, pricePerKwh, milesPerKwh, calculateCosts]);

  const handleCarChange = (e) => {
    const car = carOptions.find(car => car.name === e.target.value);
    if (car) {
      setMilesPerKwh(car.value);
      setSelectedCar(car.name);
    } else {
      setMilesPerKwh(4); // Reset to default if no car is selected
      setSelectedCar('');
    }
  };

  const handleMilesPerKwhChange = (e) => {
    setMilesPerKwh(e.target.value);
    setSelectedCar(''); // Reset car selection if miles per kWh is manually changed
  };

  const handlePricePerKwhChange = (e) => {
    const value = e.target.value;
    if (value.startsWith('0.') && !isNaN(value)) {
      setPricePerKwh(parseFloat(value));
    }
  };

  return (
    <div className="gas-cost-calculator ev-cost">
      <div className="input-container">
        <div className="input-group">
          <label>
            Monthly Distance (miles):
            <input type="number" value={distance} onChange={(e) => setDistance(e.target.value)} />
          </label>
          <label>
            Price per kWh (cents):
            <input type="text" value={`0.${pricePerKwh.toString().split('.')[1] || ''}`} onChange={handlePricePerKwhChange} />
          </label>
        </div>
        <div className="input-group">
          <label>
            Miles per kWh:
            <input type="number" value={milesPerKwh} onChange={handleMilesPerKwhChange} />
          </label>
          <label>
            Choose car (optional):
            <select value={selectedCar} onChange={handleCarChange}>
              <option value="">Default</option>
              {carOptions.map(car => (
                <option key={car.name} value={car.name}>{car.name}</option>
              ))}
            </select>
          </label>
        </div>
        <button className="calculate-button" onClick={calculateCosts}>
          Calculate
        </button>
      </div>
      <div className="cost-results">
        <div className="cost-block">
          <h3>Monthly Cost</h3>
          <p>${monthlyCost}</p>
        </div>
        <div className="cost-block">
          <h3>Yearly Cost</h3>
          <p>${yearlyCost}</p>
        </div>
      </div>
    </div>
  );
};

export default EVCostCalculator;